module.exports = __webpack_public_path__ + "img/case27.022cef87.png";